import { GRID_DIRECTION } from "../const/grid-directions.const";

export function createNestedCircle(x, y, radius, fills, ctx, customStyle) {
    const circles = radius.length;
    // The starting angle, in radians (0 is at the 3 o'clock position of the arc's circle)
    const startAngle = 0;
    // The ending angle, in radians
    const endAngle = Math.PI * 2;
    const fillKeys = Object.keys(fills);
    for (let circle = 0; circle < circles; circle++) {
        ctx.beginPath();
        ctx.fillStyle = customStyle && customStyle.fillStyle ? customStyle.fillStyle : fills[fillKeys[circle]];
        if (customStyle && customStyle.lineWidth) ctx.lineWidth = customStyle.lineWidth;
        ctx.arc(x, y, radius[circle], startAngle, endAngle);
        ctx.fill();
        if (customStyle && customStyle.strokeStyle && !customStyle.resetlineWidth) {
            ctx.strokeStyle = customStyle.strokeStyle;
            ctx.stroke();
        }
        ctx.closePath();
    }
}

export function notificationBellShape(x, y, fillStyle, ctx) {
    ctx.beginPath();
    ctx.moveTo(x - 4, y + 5);
    ctx.lineTo(x + 4, y + 5);
    ctx.lineTo(x, y);
    ctx.fillStyle = fillStyle;
    ctx.strokeStyle = fillStyle;
    ctx.stroke();
    ctx.fill();
    ctx.closePath();

    ctx.beginPath();
    ctx.moveTo(x, y - 5);
    ctx.lineTo(x, y + 5);
    ctx.fillStyle = fillStyle;
    ctx.strokeStyle = fillStyle;
    ctx.stroke();
    ctx.fill();
    ctx.closePath();

    ctx.beginPath();
    ctx.moveTo(x - 3, y + 2);
    ctx.bezierCurveTo(x - 3, y - 5, x + 3, y - 5, x + 3, y + 2);
    ctx.fillStyle = fillStyle;
    ctx.strokeStyle = fillStyle;
    ctx.stroke();
    ctx.fill();
    ctx.closePath();

    ctx.beginPath();
    ctx.moveTo(x - 3, y + 2);
    ctx.bezierCurveTo(x - 1, y + 2, x - 1, y + 4, x - 5, y + 5);
    ctx.fillStyle = fillStyle;
    ctx.strokeStyle = fillStyle;
    ctx.stroke();
    ctx.fill();
    ctx.closePath();

    ctx.beginPath();
    ctx.moveTo(x + 3, y + 2);
    ctx.bezierCurveTo(x + 1, y + 2, x + 1, y + 4, x + 5, y + 5);
    ctx.fillStyle = fillStyle;
    ctx.strokeStyle = fillStyle;
    ctx.stroke();
    ctx.fill();
    ctx.closePath();

    ctx.beginPath();
    ctx.moveTo(x - 1, y + 5);
    ctx.bezierCurveTo(x - 1, y + 6, x + 1, y + 6, x + 1, y + 6);
    ctx.fillStyle = fillStyle;
    ctx.strokeStyle = fillStyle;
    ctx.stroke();
    ctx.fill();
    ctx.closePath();
}

export function drawArrowInsideCircle(x, y, radius, style, dir, ctx) {
    const centerY = (radius * 30 / 100) + 2;
    const center = getCenter(dir, x, y, centerY, radius);
    const lines = drawLinesForInsideArrow(dir, x, y, radius);
    const previousLineWidth = ctx.lineWidth;
    ctx.beginPath();

    ctx.strokeStyle = style.stroke;
    ctx.lineWidth = style.lineWidth;
    ctx.moveTo(center.x, center.y);
    ctx.lineTo(lines.one.x, lines.one.y);
    ctx.moveTo(center.x, center.y);
    ctx.lineTo(lines.two.x, lines.two.y);
    ctx.stroke();
    ctx.closePath();
    ctx.lineWidth = previousLineWidth;
}

function getCenter(dir, x, y, centerY, radius) {
    let returnValues;
    switch (dir) {
        case GRID_DIRECTION.TOP:
            returnValues = { x, y: y - centerY + 2 };
            break;
        case GRID_DIRECTION.RIGHT:
            returnValues = { x: x + centerY - 2, y };
            break;
        case GRID_DIRECTION.BOTTOM:
            returnValues = { x, y: y + centerY - 2 };
            break;
        case GRID_DIRECTION.LEFT:
            returnValues = { x: x - centerY + 2, y };
            break;
        case GRID_DIRECTION.TOP_RIGHT:
            returnValues = { x: x + centerY, y: y - centerY };
            break;
        case GRID_DIRECTION.TOP_LEFT:
            returnValues = { x: x - centerY, y: y - centerY };
            break;
        case GRID_DIRECTION.BOTTOM_LEFT:
            returnValues = { x: x - centerY, y: y + centerY };
            break;
        case GRID_DIRECTION.BOTTOM_RIGHT:
            returnValues = { x: x + centerY, y: y + centerY };
            break;
    }
    return returnValues;
}

function drawLinesForInsideArrow(dir, x, y, radius) {
    let lines = {
        one: { x: x + radius / 1.8, y: y - (radius / 5) },
        two: { x: x - radius / 1.8, y: y - (radius / 5) }
    };
    const topCenteringOffset = 2;

    switch (dir) {
        case GRID_DIRECTION.TOP:
            lines = {
                one: { x: x + radius / 2, y: y + (radius / 5) + topCenteringOffset },
                two: { x: x - radius / 2, y: y + (radius / 5) + topCenteringOffset }
            };
            break;

        case GRID_DIRECTION.RIGHT:
            lines = {
                one: { x: x - radius / 5, y: y - radius / 2.4 },
                two: { x: x - radius / 5, y: y + (radius / 2.4) }
            };
            break;

        case GRID_DIRECTION.BOTTOM:
            lines = {
                one: { x: x + radius / 2.4, y: y - (radius / 5) },
                two: { x: x - radius / 2.4, y: y - (radius / 5) }
            };
            break;

        case GRID_DIRECTION.LEFT:
            lines = {
                one: { x: x + radius / 5, y: y - (radius / 2.4) },
                two: { x: x + radius / 5, y: y + (radius / 2.4) }
            };
            break;

        case GRID_DIRECTION.TOP_RIGHT:
            lines = {
                one: { x: x + radius / 4, y: y + radius / 2 },
                two: { x: x - radius / 2, y: y - radius / 4 }
            };
            break;

        case GRID_DIRECTION.TOP_LEFT:
            lines = {
                one: { x: x - radius / 4, y: y + radius / 2 },
                two: { x: x + radius / 2, y: y - radius / 4 }
            };
            break;

        case GRID_DIRECTION.BOTTOM_LEFT:
            lines = {
                one: { x: x + radius / 2, y: y + radius / 4 },
                two: { x: x - radius / 4, y: y - radius / 2 }
            };
            break;

        case GRID_DIRECTION.BOTTOM_RIGHT:
            lines = {
                one: { x: x - radius / 2, y: y + radius / 4 },
                two: { x: x + radius / 4, y: y - radius / 2 }
            };
            break;
    }
    return lines;
}

export function drawConnectingLine(from, to, styles, ctx) {
    ctx.beginPath();
    const savedLineWith = ctx.lineWidth;
    ctx.strokeStyle = styles.strokeStyle;
    ctx.lineWidth = styles.lineWidth || 1;
    ctx.moveTo(from.x, from.y);
    ctx.lineTo(to.x, to.y);
    ctx.stroke();
    ctx.lineWidth = savedLineWith;
    ctx.closePath();
}

export function lineLength(pointA, pointB) {
    const a = pointA.x - pointB.x;
    const b = pointA.y - pointB.y;
    return Math.sqrt(a * a + b * b);
}

export function drawConnectingLineMultiplePoints(path, styles, ctx) {
    ctx.beginPath();
    const savedLineWith = ctx.lineWidth;
    ctx.strokeStyle = styles.strokeStyle;
    ctx.lineWidth = styles.lineWidth || 1;
    ctx.moveTo(path[0].x, path[0].y);
    for (let i = 1; i < path.length; i++) {
        // clear previous line
        // let segmentLength = lineLength(path[i - 1], path[i]);
        // let toClearWidth = path[i - 1].x !== path[i].x && path[i - 1].y === path[i].y ? segmentLength : ctx.lineWidth;
        // let toClearHeight = path[i - 1].y !== path[i].y && path[i - 1].x === path[i].x ? segmentLength : ctx.lineWidth;
        // ctx.clearRect(path[i - 1].x, path[i - 1].y, toClearWidth, toClearHeight);

        const lineToX = path[i].x;
        const lineToY = path[i].y;

        ctx.lineTo(lineToX, lineToY);
    }
    ctx.stroke();
    ctx.lineWidth = savedLineWith;
    ctx.closePath();
}

export function calculateMultiplePointSegmentMidpoint(paths) {
    const eachPathLineLength = [];
    for (let i = 0; i < paths.length; i++) {
        if (paths[i] && paths[i + 1]) {
            eachPathLineLength.push({
                pointA: paths[i],
                pointB: paths[i + 1],
                lineLength: lineDistance(paths[i], paths[i + 1])
            });
        } else {
            break;
        }
    }
    const middlePathLength = eachPathLineLength.reduce((acumulator, currentValue) => (acumulator + currentValue.lineLength), 0) / 2;
    let counter = 0;
    let middlePointCoordonates = null;
    for (let i = 0; i < eachPathLineLength.length; i++) {
        if ((counter + eachPathLineLength[i].lineLength) < middlePathLength) {
            counter += eachPathLineLength[i].lineLength;
        } else {
            const need = middlePathLength - counter;
            middlePointCoordonates = getCoordinateByLength(eachPathLineLength[i].pointA, eachPathLineLength[i].pointB, need);
            break;
        }
    }
    return middlePointCoordonates;
}

function getCoordinateByLength(point1, point2, length) {
    const dx = point2.x - point1.x;
    const dy = point2.y - point1.y;
    const distance = Math.sqrt(dx * dx + dy * dy);
    if (distance === 0) return { x: point1.x, y: point1.y };

    const rx = point1.x + (point2.x - point1.x) * length / distance;
    const ry = point1.y + (point2.y - point1.y) * length / distance;
    return { x: rx, y: ry };
}

function lineDistance(point1, point2) {
    let xs = 0;
    let ys = 0;

    xs = point2.x - point1.x;
    xs *= xs;

    ys = point2.y - point1.y;
    ys *= ys;

    return Math.sqrt(xs + ys);
}

export function drawConnectingLinePointer(path, fill, endSide, triangleSideLength, ctx, gridConfig) {
    ctx.beginPath();
    if (endSide === GRID_DIRECTION.LEFT) {
        const x = path.x - triangleSideLength;
        ctx.moveTo(x + triangleSideLength / 2, path.y);
        ctx.lineTo(x - triangleSideLength, path.y - (triangleSideLength * 2 / 3));
        ctx.lineTo(x - triangleSideLength, path.y + (triangleSideLength * 2 / 3));
    } else if (endSide === GRID_DIRECTION.TOP) {
        const y = path.y - triangleSideLength;
        ctx.moveTo(path.x, y + triangleSideLength / 2);
        ctx.lineTo(path.x - (triangleSideLength * 2 / 3), y - triangleSideLength);
        ctx.lineTo(path.x + (triangleSideLength * 2 / 3), y - triangleSideLength);
    } else if (endSide === GRID_DIRECTION.RIGHT) {
        const x = path.x + triangleSideLength;
        ctx.moveTo(x - triangleSideLength / 2, path.y);
        ctx.lineTo(x + triangleSideLength, path.y - (triangleSideLength * 2 / 3));
        ctx.lineTo(x + triangleSideLength, path.y + (triangleSideLength * 2 / 3));
    } else if (endSide === GRID_DIRECTION.BOTTOM) {
        const y = path.y + triangleSideLength;
        ctx.moveTo(path.x, y - triangleSideLength / 2);
        ctx.lineTo(path.x - (triangleSideLength * 2 / 3), y + triangleSideLength);
        ctx.lineTo(path.x + (triangleSideLength * 2 / 3), y + triangleSideLength);
    }
    ctx.fillStyle = fill;
    ctx.fill();
    ctx.closePath();
}
export function drawMiddleCircleConnectingLine(midPoint, midPointRadius, middleLineFillStyle, ctx) {
    ctx.beginPath();
    ctx.fillStyle = middleLineFillStyle;
    ctx.arc(midPoint.x, midPoint.y, midPointRadius, 0, Math.PI * 2);
    ctx.fill();
    ctx.closePath();
}

export function calculateLineSegmentMidpoint(pointA, pointB) {
    return { x: (pointA.x + pointB.x) / 2, y: (pointA.y + pointB.y) / 2 };
}

export function filterArrowCellCorners(showArrowCorners, direction) {
    if (direction === GRID_DIRECTION.TOP || direction === GRID_DIRECTION.RIGHT
        || direction === GRID_DIRECTION.BOTTOM || direction === GRID_DIRECTION.LEFT) {
        return true;
    } if ((direction === GRID_DIRECTION.TOP_RIGHT || direction === GRID_DIRECTION.TOP_LEFT
        || direction === GRID_DIRECTION.BOTTOM_RIGHT || direction === GRID_DIRECTION.BOTTOM_LEFT) && showArrowCorners) {
        return true;
    } return false;
}

export function expandableRightBottomTriangle(x, y, points, width, style, ctx) {
    ctx.beginPath();
    ctx.moveTo(x, y);
    points.forEach(point => {
        ctx.lineTo(point.x, point.y);
    });
    if (style.fillStyle) {
        ctx.fillStyle = style.strokeStyle;
        ctx.strokeStyle = style.strokeStyle;
    }
    ctx.fill();
    ctx.stroke();
    ctx.closePath();
}

export function expandableRightBottomQuadrant(x, y, width, qStyle, ctx) {
    ctx.beginPath();
    ctx.moveTo(x, y);
    if (qStyle.fillStyle) {
        ctx.fillStyle = qStyle.strokeStyle;
        ctx.strokeStyle = qStyle.strokeStyle;
    }
    ctx.arc(x, y, width, Math.PI, 3 * Math.PI / 2, false);
    ctx.fill();
    ctx.stroke();
    ctx.closePath();
}
